/**
 * 공통함수
 */

const Utils = (function () {
  /**
   * Set Input Formatter With cleave.js
   */
  function setInputFormatter() {
    /**
     * 정수
     */
    const fnIntegerFormatter = function () {
      const $el = $(this);
      const min = $el.attr('min');
      const max = $el.attr('max');

      const cleave = new Cleave(this, {
        numeral: true,
        numeralDecimalMark: '',
        numeralPositiveOnly: true,
        numeralDecimalScale: 0,
        numeralThousandsGroupStyle: 'none',
        onValueChanged(e) {
          if (max !== undefined && e.target.rawValue !== '' && Number(e.target.rawValue) > Number(max)) {
            this.setRawValue(max);
          }
        },
      });

      $el.on('blur', function () {
        if (this.value === '') return;
        let numVal = Number(this.value);
        if (min !== undefined && numVal < Number(min)) numVal = Number(min);
        cleave.setRawValue(numVal);
      });

      $(document).off('input', 'input[data-type="integer"]', fnIntegerFormatter);
    };
    /**
     * 소수
     */
    const fnDecimalFormatter = function () {
      new Cleave(this, {
        numeral: true,
        numeralDecimalMark: '.',
        delimiter: '',
        numeralDecimalScale: 20,
      });
      $(document).off('input', 'input[data-type="decimal"]', fnDecimalFormatter);
    };
    /**
     * 한글
     */
    const fnKoFormatter = function () {
      $(this).val(
        $(this)
          .val()
          .replace(/[^가-힣ㄱ-ㅎㅏ-ㅣ\s]/g, ''),
      );
    };
    /**
     * 영문
     */
    const fnEnFormatter = function () {
      $(this).val(
        $(this)
          .val()
          .replace(/[^a-zA-Z\s]/g, ''),
      );
    };
    /**
     * 날짜
     */
    const fnDateFormatter = function () {
      new Cleave(this, {
        date: true,
        delimiter: '-',
        datePattern: ['Y', 'm', 'd'],
      });
      $(document).off('input', 'input[data-type="date"]', fnDateFormatter);
    };
    /**
     * 시간
     */
    const fnDatetimeFormatter = function () {
      new Cleave(this, {
        delimiters: ['-', '-', ' ', ':', ':'],
        blocks: [4, 2, 2, 2, 2, 2],
        numericOnly: true,
      });
      $(document).off('input', 'input[data-type="datetime"]', fnDatetimeFormatter);
    };
    /**
     * 전화번호
     */
    const fnPhoneFormatter = function () {
      // 입력 필드에서 숫자가 아닌 문자는 모두 제거합니다.
      this.value = this.value.replace(/\D/g, '');

      // 현재 입력된 값을 가져옵니다.
      let phone = this.value;

      // 대한민국 전화번호 형식 적용
      if (phone.startsWith('02')) {
        // 서울 번호: 02-XXXX-XXXX
        phone = phone.replace(/(\d{2})(\d{0,4})(\d{0,4})/, function (_, p1, p2, p3) {
          return p1 + (p2 ? `-${p2}` : '') + (p3 ? `-${p3}` : '');
        });
      } else if (phone.startsWith('1')) {
        // 특수 번호 (예: 1577-XXXX)
        phone = phone.replace(/(\d{4})(\d{0,4})/, function (_, p1, p2) {
          return p1 + (p2 ? `-${p2}` : '');
        });
      } else if (phone.length >= 10 && phone.startsWith('0')) {
        // 다른 지역번호: 0XX-XXX-XXXX 또는 0XX-XXXX-XXXX
        phone = phone.replace(/(\d{3})(\d{3,4})(\d{4})/, function (_, p1, p2, p3) {
          return `${p1}-${p2}-${p3}`;
        });
      } else {
        // 휴대전화: 010-XXXX-XXXX 형식
        phone = phone.replace(/(\d{3})(\d{0,4})(\d{0,4})/, function (_, p1, p2, p3) {
          return p1 + (p2 ? `-${p2}` : '') + (p3 ? `-${p3}` : '');
        });
      }

      this.value = phone.slice(0, 13);
    };

    $(document).on('input', 'input[data-type="integer"]', fnIntegerFormatter);
    $(document).on('input', 'input[data-type="decimal"]', fnDecimalFormatter);
    $(document).on('input', 'input[data-type="ko"]', fnKoFormatter);
    $(document).on('input', 'input[data-type="en"]', fnEnFormatter);
    $(document).on('input', 'input[data-type="date"]', fnDateFormatter);
    $(document).on('input', 'input[data-type="datetime"]', fnDatetimeFormatter);
    $(document).on('input', 'input[data-type="phone"]', fnPhoneFormatter);
  }

  /**
   * Set File Upload Event
   * Validates uploaded file against expected columns (from data attribute or global variable).
   */
  function setFileUploadEvent() {
    // 기본 업로드
    $(document).on('change', '.upload-wrap input[type="file"]', function (e) {
      const file = e.target.files[0];
      const $target = $(this).closest('.upload-wrap').find('div.form-control');

      if(file) {
        const url = URL.createObjectURL(file);
        $target.removeClass('empty');
        $target.empty().append(`
        <a href="${url}" class="file-link" download="${file.name}">
          <i class="material-icons-outlined me-4">save_alt</i>
          <span class="file-name">${file.name.slice(0, file.name.lastIndexOf('.'))}</span>
          <span class="file-ext">.${file.name.slice(file.name.lastIndexOf('.') + 1)}</span>
        </a>
        `);
      }
    });
    // 일괄 업로드
    $(document).on('change', '.batch-upload-wrap input[type="file"]', function (e) {
      const $targetInput = $(this).next('input[type="text"]');
      const file = e.target.files[0];

      if (file) {
        const fileName = file.name;
        const extension = fileName.split('.').pop().toLowerCase();
        const baseName = fileName.substring(0, fileName.lastIndexOf('.'));

        // extension validation
        if (extension !== 'xlsx') {
          Utils.showToast('Only xlsx extension can be uploaded.', 'danger');
          $(this).val('');
          $targetInput.val('');
          $targetInput.removeClass('disabled');
          return;
        }

        // filename validation (no spaces or special characters)
        const nameRegex = /^[a-zA-Z0-9_-]+$/;
        if (!nameRegex.test(baseName)) {
          Utils.showToast('No spaces or special characters in file names.', 'danger');
          $(this).val('');
          $targetInput.val('');
          $targetInput.removeClass('disabled');
          return;
        }

        const reader = new FileReader();

        reader.onload = function (event) {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // 첫 번째 시트 가져오기
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          let expectedColumns = [];

          expectedColumns = Utils.global.uploadColumns.map((col) => col.title.replace(/\s/g, ''));

          // JSON 데이터로 변환
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          let headerIndex = -1;

          // 컬럼 유효성 검사
          if (expectedColumns.length > 0) {
            // Check Row 0
            const row0 = jsonData[0] ? jsonData[0].map((c) => (c || '').toString().trim().replace(/\s/g, '')) : [];
            if (expectedColumns.length === row0.length && expectedColumns.every((c, i) => c === row0[i])) {
              headerIndex = 0;
            }

            // Check Row 1
            if (headerIndex === -1) {
              const row1 = jsonData[1] ? jsonData[1].map((c) => (c || '').toString().trim().replace(/\s/g, '')) : [];
              if (expectedColumns.length === row1.length && expectedColumns.every((c, i) => c === row1[i])) {
                headerIndex = 1;
              }
            }

            if (headerIndex === -1) {
              Utils.showToast('This file is not an uploadable format.', 'danger');

              // 입력 초기화
              $targetInput.val('');
              $(this).val('');
              $targetInput.removeClass('disabled');
              Utils.global.uploadTable = null;
              return;
            }
          }

          // 행 개수 확인 (헤더 제외 여부는 정책에 따라 결정, 여기선 전체 행 기준)
          if (jsonData.length > 10000) {
            Utils.showToast('Only 10,000 or fewer data items can be uploaded.', 'danger');
            // 입력 초기화
            $targetInput.val('');
            $(this).val('');
            $targetInput.removeClass('disabled');
            Utils.global.uploadTable = null;
            return;
          }

          // 정상 파일인 경우 파일명 표시
          $targetInput.val(file.name);
          $targetInput.addClass('disabled');

          // 데이터 전달
          $(this).trigger('upload-success', [jsonData, headerIndex]);
        }.bind(this);

        reader.readAsArrayBuffer(file);
      } else {
        $targetInput.val('');
        $(this).val('');
        $targetInput.removeClass('disabled');
        $('#tableContainer').html('');
        Utils.global.uploadTable = null;
      }
    });
    $(document).on('click', '#btnUploadCancel', function () {
      const $targetInput = $('.batch-upload-wrap input[type="file"]');
      $targetInput.val('').trigger('change');
    });
    // 이미지 업로드
    let newImageIndex = 0;

    function refreshImgLabelIndex() {
      const $imgUploadWraps = $('.img-upload-wrap:visible');
      $imgUploadWraps.each(function (index) {
        const newNum = ($imgUploadWraps.length - index).toString().padStart(2, '0');
        $(this).find('span.label').text(newNum);

        const imageType = $(this).attr('data-image-type');
        const imageId = $(this).attr('data-image-id');

        if (imageType === 'existing' && imageId) {
          $(this).find('input[type="file"]').attr('id', `imageUpload_ex_${imageId}`);
          $(this).find('label[for]').attr('for', `imageUpload_ex_${imageId}`);
        } else if (index > 0) {
          const fileId = `imageUpload_${newNum}`;
          $(this).find('input[type="file"]').attr('id', fileId);
          $(this).find('label[for]').attr('for', fileId);
        }
      });
    }

    // Initialize existing images on page load
    function initializeExistingImages() {
      if (typeof window.existingImages === 'undefined' || window.existingImages.length === 0) {
        return;
      }

      const $container = $('.img-upload-wrap').parent();
      const $template = $('.img-upload-wrap').first();

      window.existingImages.forEach((image, index) => {
        const $wrap = $template.clone();
        $wrap.attr('data-image-type', 'existing');
        $wrap.attr('data-image-id', image.id);

        const labelNum = String(window.existingImages.length - index).padStart(2, '0');
        $wrap.find('span.label').text(labelNum);

        // Set values
        const $orderInput = $wrap.find('input[type="number"]');
        const $captionInput = $wrap.find('textarea');
        $orderInput.val(image.display_order);
        $orderInput.attr('name', `existing_order_${image.id}`);
        $captionInput.val(image.caption);
        $captionInput.attr('name', `existing_caption_${image.id}`);

        // Update file input
        const fileInputId = `imageUpload_ex_${image.id}`;
        const $fileInput = $wrap.find('input[type="file"]');
        $fileInput.attr('id', fileInputId);
        $fileInput.attr('name', `replace_image_${image.id}`);
        $wrap.find('label[for]').attr('for', fileInputId);

        // Add existing image preview using img-wrap
        $wrap.find('label[for]').addClass('d-none');
        $wrap.find('.d-flex.gap-8').parent().append(`
          <div class="img-wrap">
            <img src="${image.url}" alt="existing image">
            <button type="button" class="btn btn-sm btn-outline-primary btn-icon btn-img-remove">
              <i class="material-icons">delete</i>
            </button>
          </div>
        `);

        // Add delete button
        $wrap.find('label[for]').after(`
          <button type="button" class="btn btn-outline btn-sm btn-icon btn-remove d-none">
            <i class="material-icons">delete</i>
          </button>
        `);

        $container.append($wrap);

        // Attach btn-img-remove event for existing images
        $wrap.find('.btn-img-remove').on('click', function () {
          $wrap.find('label[for]').removeClass('d-none');
          $wrap.find('.btn-remove').removeClass('d-none');
          $(this).parent().remove();
          $wrap.find('input[type="file"]').val('').removeAttr('name');
        });

        // Attach btn-remove event for existing images
        $wrap.find('.btn-remove').on('click', function () {
          // Add hidden checkbox to mark for deletion
          $wrap.append(`<input type="checkbox" name="delete_image" value="${image.id}" checked style="display:none;">`);
          $wrap.hide();
          refreshImgLabelIndex();
        });
      });

      // Update first wrap label
      if (window.existingImages.length > 0) {
        const newLabel = String(window.existingImages.length + 1).padStart(2, '0');
        $template.find('span.label').text(newLabel);
      }
    }

    $(document).ready(function() {
      initializeExistingImages();
    });

    $(document).on('change', '.img-upload-wrap input[type="file"]', function (e) {
      const $imgUploadWrap = $(this).closest('.img-upload-wrap');
      const $this = $(this);
      const file = e.target.files[0];

      if(file) {
        const imageType = $imgUploadWrap.attr('data-image-type');
        const imageId = $imgUploadWrap.attr('data-image-id');

        // Set proper name attributes
        if (imageType === 'existing' && imageId) {
          // Already set during initialization
          $imgUploadWrap.find('input[type="number"]').attr('name', `existing_order_${imageId}`);
          $imgUploadWrap.find('textarea').attr('name', `existing_caption_${imageId}`);
        } else {
          // New image
          const idx = newImageIndex;
          $this.attr('name', `new_image_${idx}`);
          $imgUploadWrap.find('input[type="number"]').attr('name', `new_order_${idx}`);
          $imgUploadWrap.find('textarea').attr('name', `new_caption_${idx}`);
          $imgUploadWrap.attr('data-new-index', idx);
          newImageIndex++;
        }

        $imgUploadWrap.find(`label[for="${$(this).attr('id')}"], .btn-remove`).addClass('d-none');
        const url = URL.createObjectURL(file);
        $this.parent().append(`
        <div class="img-wrap">
          <img src="${url}" alt="${file.name}">
          <button type="button" class="btn btn-sm btn-outline-primary btn-icon btn-img-remove">
            <i class="material-icons">delete</i>
          </button>
        </div>
        `);

        $imgUploadWrap.find('.btn-img-remove').on('click', function () {
          $imgUploadWrap.find(`label[for="${$this.attr('id')}"]`).removeClass('d-none');
          $imgUploadWrap.find('.btn-remove').removeClass('d-none');
          $(this).parent().remove();
          $imgUploadWrap.find('input[type="file"]').val('');
          $this.removeAttr('name');

          if($imgUploadWrap.index() > 0) {
            $imgUploadWrap.find(`label[for="${$this.attr('id')}"]`).after(`
            <button type="button" class="btn btn-outline btn-sm btn-icon btn-remove">
              <i class="material-icons">delete</i>
            </button>
            `);
            $imgUploadWrap.find('.btn-remove').on('click', function () {
              // Check if it's an existing image
              if (imageType === 'existing' && imageId) {
                // Add hidden checkbox to mark for deletion
                $imgUploadWrap.append(`<input type="checkbox" name="delete_image" value="${imageId}" checked style="display:none;">`);
                $imgUploadWrap.hide();
              } else {
                $imgUploadWrap.remove();
              }
              refreshImgLabelIndex();
            });
          }
        });

        if($imgUploadWrap.siblings('.img-upload-wrap:visible').length < 9) {
          // 상단영역 추가
          const $newImgUploadWrap = $imgUploadWrap.clone();
          $newImgUploadWrap.removeAttr('data-image-type');
          $newImgUploadWrap.removeAttr('data-image-id');
          $newImgUploadWrap.removeAttr('data-new-index');
          $newImgUploadWrap.find('input[type="number"]').val('').removeAttr('name');
          $newImgUploadWrap.find('textarea.form-control').val('').removeAttr('name');
          $newImgUploadWrap.find(`label[for="${$(this).attr('id')}"]`).removeClass('d-none');
          $newImgUploadWrap.find('input[type="file"]').val('').removeAttr('name');
          $newImgUploadWrap.find('.btn-remove').remove();
          $newImgUploadWrap.find('.img-wrap').remove();
          $imgUploadWrap.before($newImgUploadWrap);

          const newIndex = ($imgUploadWrap.siblings('.img-upload-wrap:visible').length + 1).toString().padStart(2, '0');
          $newImgUploadWrap.find('span.label').text(newIndex);

          refreshImgLabelIndex();
        }
      }
    });
  }

  /**
   * Set Upload Table
   */
  function setUploadTable() {
    const columns = Utils.global.uploadColumns || [];

    /**
     * 테이블 그리기
     * @param count
     * @param data
     */
    function drawTable(count, data) {
      const html = `
        <div class="card h-full">
          <div class="card-body">
            <p class="table-count"><span class="text-gray-800">Total</span> <span class="text-gray-500">${count.toLocaleString()}</span></p>
            <div id="uploadTable"></div>
          </div>
        </div>
      `;

      $('#tableContainer').html(html);

      Utils.global.uploadTable = new Tabulator('#uploadTable', {
        layout: 'fitColumns',
        height: '100%',
        selectable: false,
        renderVertical: 'virtual',
        renderVerticalBuffer: 300,
        columns,
        data,
      });
      Utils.setTabulator(Utils.global.uploadTable);
    }

    $(document).on('upload-success', '#fileUpload', function (e, jsonData, headerIndex) {
      const headers = jsonData[headerIndex];
      const rows = jsonData.slice(headerIndex + 1);
      const totalCount = rows.length;

      // 데이터 매핑
      const tableData = rows.map((row) => {
        const obj = {};
        headers.forEach((h, i) => {
          const colDef = columns.find((c) => c.title === h);
          if (colDef) {
            obj[colDef.field] = row[i];
          }
        });
        return obj;
      });

      drawTable(totalCount, tableData);
    });
  }

  /**
   * Set Header Tab Event For Accessiblity
   */
  function setHeaderTabEvent() {
    const $navItem = $('.layout-header .nav-list .nav-item');
    const $navLink = $('.logo, .layout-header .nav-list li > a, .dropdown-toggle');

    /**
     * Remove Menu Active Class
     */
    function removeMenuActive() {
      $('.layout-header .nav-list .nav-item').removeClass('active');
    }

    $navItem.on('focusin', function () {
      removeMenuActive();
      $(this).addClass('active');
    });
    $navItem.on('click', function () {
      $(this).removeClass('active');
    });
    $navLink.on('focusin', function () {
      removeMenuActive();
    });
    $(document).on('mousedown', function () {
      removeMenuActive();
    });
    $('.layout-main, .layout-footer').on('focusin', function () {
      removeMenuActive();
    });
  }

  /**
   * Set Tooltip
   */
  function setTooltip() {
    $(document).on('mouseenter', '[data-bs-toggle="tooltip"]', function () {
      $(this).tooltip({
        /**
         * 툴팁 내용
         */
        content() {
          return $(this).prop('data-bs-title');
        },
      });
      $(this).tooltip('show');
    });
  }

  /**
   * 키워드 추가
   */
  function setAddKeywordEvent() {
    $(document).on('click', '.keyword-group .btn-add', function() {
      const $keywordGroup = $(this).closest('.keyword-group');
      const $keywordWrap = $keywordGroup.find('.keyword-wrap').last();
      const $keywordWrapClone = $keywordWrap.clone();
      $keywordWrapClone.append(`
      <button type="button" class="btn-text btn-remove ms-n8">
        <i class="material-icons-outlined">remove_circle_outline</i>
      </button>
      `);
      $keywordWrap.after($keywordWrapClone);
      $keywordWrapClone.find('input').val('');
    });

    $(document).on('click', '.keyword-group .btn-remove', function() {
      const $keywordWrap = $(this).closest('.keyword-wrap');
      $keywordWrap.remove();
    });
  }

  function setTabAllEvent() {
    $(document).on('click', '.nav-tabs .nav-link', function(e) {
      const $tabContent = $(this).closest('.nav-tabs').next('.tab-content');
      const isScrollTabs = $(this).closest('.nav-tabs').hasClass('scroll-tabs');
      const $targetPane = $($(this).data('bs-target'));
      const $panes = $tabContent.find('.tab-pane');
      
      if(isScrollTabs) {
        $tabContent.addClass('show-all');
        $panes.addClass('active show');

        setTimeout(() => {
          $panes.addClass('show');
        }, 160);

        const $scrollContainer = $tabContent;
        if ($targetPane.length > 0) {
          let scrollTop = $targetPane.position().top + $scrollContainer.scrollTop() - 64;
          if(scrollTop < 50) scrollTop = 0;
          $scrollContainer.stop().animate({ scrollTop }, 300);
        } else {
          $scrollContainer.stop().animate({ scrollTop: 0 }, 300);
        }
      } else {
        if($targetPane.length > 0) {
          $targetPane.siblings().removeClass('active show');
        } else {
          $tabContent.addClass('show-all');
          $panes.addClass('active');
  
          setTimeout(() => {
            $panes.addClass('show');
          }, 160);
        }
      }
    });
  }

  function setImgModalEvent() {
    $(document).on('click', 'button.img-wrap', function(e) {
      // Skip if Bootstrap modal is already configured
      if ($(this).data('bs-toggle') === 'modal') {
        return;
      }
      e.preventDefault();
      const $img = $(this).find('img');
      const src = $img.attr('src');
      const alt = $img.attr('alt');
      const id = `commonImageModal_${new Date().getTime()}`;

      const modalHtml = `
      <div class="modal fade" id="${id}" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content mb-0">
            <div class="modal-header">
              <h5 class="modal-title">${alt}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal">
                <i class="material-icons-outlined">cancel</i>
              </button>
            </div>
            <div class="modal-body">
              <div class="img-wrap">
                <img src="${src}" alt="${alt}">
              </div>
            </div>
          </div>
        </div>
      </div>
      `;

      $('body').append(modalHtml);

      const $modal = $(`#${id}`);
      $modal.modal('show');

      $modal.on('hidden.bs.modal', function () {
        $modal.remove();
      });
    });
  }

  function setImgDownloadEvent() {
    $(document).on('click', '.btn-img-download', function(e) {
      const $target = $($(this).data('target'));
      const fileName = $(this).data('download');
      html2canvas($target[0], {
        allowTaint: true,
        useCORS: true,
        scale: 2,
      })
      .then(function (canvas) {
        const captureImgData = canvas.toDataURL('image/jpeg');
        const downloadLink = document.createElement('a');

        downloadLink.href = captureImgData;
        downloadLink.download = fileName ? `${fileName}.jpeg` : 'download.jpeg';
        downloadLink.click();

        downloadLink.remove();
      });
    });
  }

  function setTextareaEvent() {
    $(document).on('input', 'textarea.form-control', function() {
      Utils.setTextareaResize(this);
    });
    Utils.setTextareaResize();
  }

  /**
   * Set Signup Validation and Navigation
   */
  function setSignupValidation() {
    const $signupStep1 = $('#signup-step-1');
    if (!$signupStep1.length) return;

    const $nextBtn = $('#signup-step-1-next');
    const $carousel = $('#loginCarousel');

    // Input field to validation type mapping
    const validationMap = {
      'firstName': 'firstName',
      'lastName': 'lastName',
      'signInId': 'email',
      'signInPwd': 'password',
      'signInConfirmPwd': 'confirmPassword'
    };

    // Check if all required fields are filled
    function checkRequiredFields() {
      const $inputs = $signupStep1.find('input');
      let allFilled = true;

      $inputs.each(function() {
        if (!$(this).val().trim()) {
          allFilled = false;
          return false;
        }
      });

      $nextBtn.prop('disabled', !allFilled);
    }

    // Remove validation errors
    function removeValidationError($input) {
      $input.removeClass('is-invalid');
      $input.next('.invalid-feedback').remove();
    }

    // Show validation error
    function showValidationError($input, message) {
      $input.addClass('is-invalid');
      $input.next('.invalid-feedback').remove();
      $input.after(`<p class="invalid-feedback">${message}</p>`);
    }

    // Reset form inputs
    function resetStepInputs($step) {
      setTimeout(() => {
        $step.find('input, select').each(function() {
          $(this).val('').trigger('change').removeClass('is-invalid');
        });
        $step.find('.invalid-feedback').remove();
        checkRequiredFields();
      }, 600);
    }

    // Validate all fields in step 1
    function validateStep1() {
      let isValid = true;

      $signupStep1.find('input').each(function() {
        const $input = $(this);
        const inputId = $input.attr('id');
        const validationType = validationMap[inputId];

        if (!validationType) return;

        // Remove previous errors
        removeValidationError($input);

        // Run validation
        const result = Utils.validation(validationType, $input);

        if (!result.valid) {
          showValidationError($input, result.message);
          isValid = false;
        }
      });

      return isValid;
    }

    // Check required fields on input
    $signupStep1.find('input').on('input', function() {
      checkRequiredFields();
    });

    // Validate on Next button click
    $nextBtn.on('click', function(e) {
      e.preventDefault();

      if (validateStep1()) {
        // Manually move to next slide using jQuery Bootstrap carousel
        $carousel.carousel('next');
      }
    });

    // Reset on Back button click for all steps (event delegation)
    $(document).on('click', '.carousel-item button[data-bs-slide="prev"]', function() {
      const $step = $(this).closest('.carousel-item');
      resetStepInputs($step);
    });

    // Initial check
    checkRequiredFields();

    // ===== Step 2 Validation =====
    const $signupStep2 = $('#signup-step-2');
    if ($signupStep2.length) {
      const $submitBtn = $('#signup-step-2-submit');

      // Check if all required fields in step 2 are filled
      function isFilled($el) {
        const value = $el.val();

        // multiple select 등: 배열이면 length로 판단
        if (Array.isArray(value)) {
          return value.length > 0;
        }

        // null/undefined 방지
        if (value === null || value === undefined) {
          return false;
        }

        // number 등도 string으로 변환해서 trim
        return String(value).trim().length > 0;
      }

      function checkRequiredFieldsStep2() {
        const $companyName = $('#companyName');
        const $jobRole = $('#jobRole');
        const $interestIn = $('#interestIn');

        const allFilled = isFilled($companyName) && isFilled($jobRole) && isFilled($interestIn);
        $submitBtn.prop('disabled', !allFilled);
      }


      // Validate all fields in step 2
      function validateStep2() {
        let isValid = true;

        // Validate Company Name
        const $companyName = $('#companyName');
        removeValidationError($companyName);
        const companyNameResult = Utils.validation('required', $companyName);
        if (!companyNameResult.valid) {
          showValidationError($companyName, companyNameResult.message);
          isValid = false;
        }

        // Validate Job Role
        const $jobRole = $('#jobRole');
        removeValidationError($jobRole);
        const jobRoleResult = Utils.validation('required', $jobRole);
        if (!jobRoleResult.valid) {
          showValidationError($jobRole, jobRoleResult.message);
          isValid = false;
        }

        // Validate Interest In
        const $interestIn = $('#interestIn');
        removeValidationError($interestIn);
        const interestInResult = Utils.validation('required', $interestIn);
        if (!interestInResult.valid) {
          showValidationError($interestIn, interestInResult.message);
          isValid = false;
        }

        return isValid;
      }

      // Check required fields on input/change
      $('#companyName').on('input', checkRequiredFieldsStep2);
      $('#jobRole, #interestIn').on('change', checkRequiredFieldsStep2);

      // Validate on Submit button click
      $submitBtn.on('click', function(e) {
        if (!validateStep2()) {
          e.preventDefault();
          e.stopPropagation();
          $submitBtn.attr('type', 'button');
          return false;
        }

        $submitBtn.attr('type', 'submit');
        $submitBtn.trigger('click');
      });

      // Initial check
      checkRequiredFieldsStep2();
    }
  }

  /**
   * Initialize (Only Once)
   */
  function init() {
    setHeaderTabEvent();
    setInputFormatter();
    setFileUploadEvent();
    setUploadTable();
    setTooltip();
    setAddKeywordEvent();
    setTabAllEvent();
    setImgModalEvent();
    setImgDownloadEvent();
    setTextareaEvent();
    setSignupValidation();
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });

  return {
    /**
     * Global Variables
     */
    global: {
      toastHistory: null,
      uploadColumns: null,
      uploadTable: null,
    },
    validation(type, $input) {
      const raw = $input.val();

      const value = Array.isArray(raw) ? raw.join(',') : raw.trim();

      switch (type) {
        case 'firstName':
          if (!value) {
            return { valid: false, message: 'Please enter your first name.' };
          }
          if (value.length < 2) {
            return { valid: false, message: 'First name must be at least 2 characters.' };
          }
          if (value.length > 50) {
            return { valid: false, message: 'First name must not exceed 50 characters.' };
          }
          return { valid: true };

        case 'lastName':
          if (!value) {
            return { valid: false, message: 'Please enter your last name.' };
          }
          if (value.length < 2) {
            return { valid: false, message: 'Last name must be at least 2 characters.' };
          }
          if (value.length > 50) {
            return { valid: false, message: 'Last name must not exceed 50 characters.' };
          }
          return { valid: true };

        case 'email': {
          if (!value) {
            return { valid: false, message: 'Please enter your email address.' };
          }
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(value)) {
            return { valid: false, message: 'Please enter a valid email address.' };
          }
          return { valid: true };
        }

        case 'password':
          if (!value) {
            return { valid: false, message: 'Please enter your password.' };
          }
          if (value.length < 9 || value.length > 24) {
            return { valid: false, message: 'Password must be 9-24 characters.' };
          }
          // Check for at least one letter and one number
          if (!/[a-zA-Z]/.test(value) || !/[0-9]/.test(value)) {
            return { valid: false, message: 'Password must contain both letters and numbers.' };
          }
          return { valid: true };

        case 'confirmPassword': {
          if (!value) {
            return { valid: false, message: 'Please confirm your password.' };
          }
          const $passwordInput = $input.closest('form').find('input[type="password"]').first();
          const password = $passwordInput.val();
          if (value !== password) {
            return { valid: false, message: 'Passwords do not match.' };
          }
          return { valid: true };
        }

        default:
          return { valid: true };
      }
    },
    setTextareaResize() {
      const fnRemToPx = (rem) => {
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
      }
      $('textarea.form-control').each(function() {
        $(this).css('height', fnRemToPx(3.25));
        if ($(this).innerHeight() < $(this)[0].scrollHeight) {
          $(this).css('height', $(this)[0].scrollHeight + 2);
        }
      });
    },
    /**
     * 편집 모드 전환
     * @param $this
     */
    toggleEditEvent($this) {
      const $target = $($this.data('target'));
      const type = $this.data('type');
      const $toggleTarget = $target.find('[data-toggle]');

      if($toggleTarget.length > 0) {
        if (type === 'edit') {
          $this.parent().find('.btn-edit').addClass('d-none');
          $this.parent().find('.btn-cancel, .btn-save').removeClass('d-none');
        } else {
          $this.parent().find('.btn-edit').removeClass('d-none');
          $this.parent().find('.btn-cancel, .btn-save').addClass('d-none');
          $target.find('input:not([readonly]), select:not([readonly]), textarea:not([readonly])').val('');
        }

        $toggleTarget.each(function() {
          $(this).toggleClass('d-none');
        });
      } else {
        if (type === 'edit') {
          $this.parent().find('.btn-edit').addClass('d-none');
          $this.parent().find('.btn-cancel, .btn-save').removeClass('d-none');
          $target.find('input:not([readonly]), select:not([readonly]), textarea:not([readonly])').prop('disabled', false);
        } else {
          $this.parent().find('.btn-edit').removeClass('d-none');
          $this.parent().find('.btn-cancel, .btn-save').addClass('d-none');
          $target.find('input:not([readonly]), select:not([readonly]), textarea:not([readonly])').prop('disabled', true);
        }
      }

      if($this.data('type') === 'cancel') {
        $target.find('input:not([readonly]), select:not([readonly]), textarea:not([readonly])').each(function() {
          const $original = $(this).prev();
          if($original.length > 0 && $original.attr('id') && $original.attr('id').endsWith('_original')) {
            const originalVal = $original.val();
            if($(this).prop('multiple')) {
              $(this).val(originalVal ? originalVal.split(',') : []);
            } else {
              $(this).val(originalVal);
            }
            
            if($(this).hasClass('select2')) {
              $(this).trigger('change');
            }
          }
        });
      }
    },
    /**
     * 토스트 메시지
     * @param desc
     * @param type success, info, warning, danger
     */
    showToast(desc, type = 'success') {
      if (Utils.global.toastHistory != null) {
        $('.toast-message').remove();
        clearTimeout(Utils.global.toastHistory);
      }

      $('body').append(`<div class="toast-message ${type}"><p>${desc}</p></div>`);
      $('.toast-message').animate({ opacity: 1 }, 300);

      Utils.global.toastHistory = setTimeout(function () {
        $('.toast-message').animate({ opacity: 0 }, 300);
        setTimeout(function () {
          $('.toast-message').remove();
          Utils.global.toastHistory = null;
        }, 300);
      }, 3000);
    },
    /**
     * 스크롤 여부
     * @param el
     */
    getScrollYN(el) {
      if (el.scrollWidth > el.clientWidth) {
        return true;
      }
      return false;
    },
    /**
     * Set Default Tabulator
     * @param {Tabulator} table
     */
    setTabulator(table) {
      table.on('renderComplete', function () {
        const id = `#${$(this.element).attr('id')}`;
        // for checkbox custom
        const $checkbox = $(id).find('input[type="checkbox"]');
        $checkbox.addClass('form-check-input');
        
        const { columns } = table.columnManager;
        for (let i = 0; i < columns.length; i++) {
          const el = $(columns[i].contentElement).find('.tabulator-col-title')[0];
          if (Utils.getScrollYN(el)) {
            $(el).attr('data-bs-toggle', 'tooltip');
            $(el).attr('data-bs-placement', 'bottom');
            $(el).attr('data-bs-title', $(el).text());
          } else {
            $(el).removeAttr('data-bs-toggle');
            $(el).removeAttr('data-bs-placement');
            $(el).removeAttr('data-bs-title');
          }
        }
        const { rows } = table.rowManager;
        for (let i = 0; i < rows.length; i++) {
          for (let j = 0; j < rows[i].cells.length; j++) {
            const el = $(rows[i].cells[j].element)[0];
            if ($(el).hasClass('custom-progress')) {
              $(el).attr('title', rows[i].cells[j].value);
            }
            if (Utils.getScrollYN(el)) {
              $(el).attr('data-bs-toggle', 'tooltip');
              $(el).attr('data-bs-placement', 'bottom');
              $(el).attr('data-bs-title', $(el).text());
            } else {
              $(el).removeAttr('data-bs-toggle');
              $(el).removeAttr('data-bs-placement');
              $(el).removeAttr('data-bs-title');
            }
          }
        }
      });
      table.on('tableBuilt', function () {
        // reset checkbox list
        if (table.options.selectable) {
          table.getSelectedRows().forEach(function (row) {
            row.deselect();
          });
        }

        // Horizontal drag-to-scroll
        const holder = table.element.querySelector('.tabulator-tableholder');
        if (holder) {
          let isDown = false;
          let startX = 0;
          let scrollLeft = 0;

          holder.addEventListener('mousedown', function (e) {
            // Skip if clicking on interactive elements
            if (e.target.closest('input, button, a, .tabulator-col-resize-handle')) return;
            if (holder.scrollWidth <= holder.clientWidth) return;
            isDown = true;
            startX = e.pageX - holder.offsetLeft;
            scrollLeft = holder.scrollLeft;
            holder.style.cursor = 'grabbing';
            holder.style.userSelect = 'none';
          });

          holder.addEventListener('mousemove', function (e) {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - holder.offsetLeft;
            holder.scrollLeft = scrollLeft - (x - startX);
          });

          holder.addEventListener('mouseup', function () {
            isDown = false;
            holder.style.cursor = '';
            holder.style.userSelect = '';
          });

          holder.addEventListener('mouseleave', function () {
            isDown = false;
            holder.style.cursor = '';
            holder.style.userSelect = '';
          });

          /**
           * 테이블 가로스크롤 위치에 따른 클래스 추가 (최종 최적화)
           */
          const $table = $(table.element);
          let isTicking = false;

          const updateScrollClasses = () => {
            if (!isTicking) {
              requestAnimationFrame(() => {
                if (!holder) return;

                const isScrollable = holder.scrollWidth > holder.clientWidth;
                // 1px의 오차 범위를 두어 소수점 이슈 대응
                const canScrollLeft = holder.scrollLeft > 100;
                const canScrollRight = Math.ceil(holder.scrollLeft) < (holder.scrollWidth - holder.clientWidth - 100);

                $table.toggleClass('has-hscroll', isScrollable);
                $table.toggleClass('can-scroll-left', isScrollable && canScrollLeft);
                $table.toggleClass('can-scroll-right', isScrollable && canScrollRight);
                
                isTicking = false;
              });
              isTicking = true;
            }
          };

          holder.addEventListener('scroll', updateScrollClasses);

          const resizeObserver = new ResizeObserver(() => {
            updateScrollClasses();
          });
          resizeObserver.observe(holder);

          // 테이블 파괴 시 리소스 해제 (메모리 누수 방지)
          table.on('tableDestroyed', () => {
            resizeObserver.disconnect();
            holder.removeEventListener('scroll', updateScrollClasses);
          });

          // 초기 실행 및 데이터 관련 이벤트 연결
          updateScrollClasses();
          table.on('dataLoaded', updateScrollClasses);
          table.on('renderComplete', updateScrollClasses);
        }
      });
      table.on('rowSelectionChanged', function (data, rows) {
        if (rows.length > 0) {
          const $parent = $(rows[0]._row.parent.element);
          const $allCheckbox = $parent.siblings('.tabulator-header').find('input[type="checkbox"]');
          const $eachCheckboxList = $parent.find('input[type="checkbox"]');
          if (rows.length == $eachCheckboxList.length) {
            $allCheckbox.prop('indeterminate', false).prop('checked', true);
          }
        }
      });
    },
    /**
     * Set Select2
     */
    setSelect2() {
      const $select2List = $('select.select2');
      $select2List.each(function () {
        const isMultiple = $(this).prop('multiple');
        const $select = $(this);

        const options = {
          dropdownParent: $select.closest('.modal-content')[0] ? $select.closest('.modal-content') : $('body'),
          // allowClear: $select.hasClass('allow-clear'), // Disable native allowClear to prevent backspace-wipe
          minimumResultsForSearch: 10,
          // closeOnSelect: false, // Keep dropdown open after selection
          language: {
            searching: () => {
              return 'Searching...';
            },
            loadingMore: () => {
              return 'Loading...';
            },
            // maximumSelected: () => {
            //   return 'Maximum 4 selections allowed.';
            // },
            // inputTooShort: () => {
            //   return 'Please enter at least 1 character.';
            // },
            noResults: () => {
              return 'No search results.';
            },
          },
          escapeMarkup: (markup) => {
            return markup;
          },
        };
        $select.select2(options);

        // Dynamically add clear button for multiple select to avoid backspace issue
        if (isMultiple && $select.hasClass('allow-clear')) {
          const $selection = $select.next().find('.select2-selection--multiple');
          const $clearBtn = $('<span class="select2-selection__clear" title="Clear all" style="cursor:pointer;">×</span>');
          
          $selection.append($clearBtn);

          $clearBtn.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $select.val([]).trigger('change').trigger('change.select2');
            $select.select2('close');
            $select.select2('open');
          });

          // Show/Hide clear button based on value
          $select.on('change.clearBtn', function () {
            const val = $(this).val();
            if (val.length > 0) {
              $clearBtn.show();
            } else {
              $clearBtn.hide();
            }
          });
          $select.trigger('change.clearBtn');
        }

        let wasDropdownOpen = false;
        let savedScrollPosition = 0;

        $(this).on('select2:select select2:unselect change', function () {
          const select2Instance = $(this).data('select2');
          const { $dropdown } = select2Instance;
          const selectedCnt = $(this).val() ? $(this).val().length : 0;
          const optionCnt = $(this).find('option[value!=""]').length;
          
          if(selectedCnt == optionCnt) {
            $dropdown.addClass('d-none');
          } else {
            $dropdown.removeClass('d-none');
          }
        });

        // Track dropdown state before unselecting
        $(this).on('select2:unselecting', function () {
          const select2Instance = $(this).data('select2');
          wasDropdownOpen = select2Instance.isOpen();

          // Save scroll position if dropdown is open
          if (wasDropdownOpen) {
            const { $dropdown } = select2Instance;
            if ($dropdown) {
              const $results = $dropdown.find('.select2-results__options');
              savedScrollPosition = $results.scrollTop();
            }
          }
        });

        // Show deselected items immediately after deselection and keep dropdown open (multiple only)
        if (isMultiple) {
          // Backspace removes the entire last badge instead of editing it character by character.
          // Bind on capture phase to run before select2's internal keydown handler.
          const searchFieldEl = $select.next().find('.select2-search__field')[0];
          if (searchFieldEl) {
            searchFieldEl.addEventListener('keydown', function (e) {
              if (e.key !== 'Backspace' || this.value.length !== 0) return;

              const $selectedOptions = $select.find('option:selected');
              if ($selectedOptions.length === 0) return;

              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();

              $selectedOptions.last().prop('selected', false);
              $select.trigger('change');
            }, true);
          }

          $(this).on('select2:unselect', function () {
            const select2Instance = $(this).data('select2');

            // Keep dropdown open only if it was already open
            if (wasDropdownOpen) {
              setTimeout(() => {
                if (!select2Instance.isOpen()) {
                  $(this).select2('open');

                  // Restore scroll position
                  const { $dropdown: $reopenedDropdown } = $(this).data('select2');
                  if ($reopenedDropdown) {
                    const $results = $reopenedDropdown.find('.select2-results__options');
                    $results.scrollTop(savedScrollPosition);
                  }
                }
              }, 0);
            }
          });
        }
      });
    },
    setSelect2ForAjax(id, url, extraParams = {}) {
      const $target = $(`${id}`);
      $target.select2({
        dropdownParent: $target.closest('.modal-content')[0] ? $target.closest('.modal-content') : $('body'),
        minimumInputLength: 0,
        // allowClear: $target.hasClass('allow-clear'), // Disable native allowClear to prevent backspace-wipe
        minimumResultsForSearch: 10,
        // closeOnSelect: false, // Keep dropdown open after selection
        language: {
          searching: () => {
            return 'Searching...';
          },
          loadingMore: () => {
            return 'Loading...';
          },
          // maximumSelected: () => {
          //   return 'Maximum 4 selections allowed.';
          // },
          // inputTooShort: () => {
          //   return 'Please enter at least 1 character.';
          // },
          noResults: () => {
            return 'No search results.';
          },
        },
        ajax: {
          url,
          dataType: 'json',
          delay: 250,
          cache: true,
          data: function (params) {
              return {
                search: params.term || '',
                page: params.page || 1,
                ...extraParams,
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;
            return {
              results: data.results,
              pagination: { more: data.pagination.more }
            };
          },
        },
      });

      // Dynamically add clear button for multiple select to avoid backspace issue
      const isMultiple = $target.prop('multiple');
      
      if (isMultiple && $target.hasClass('allow-clear')) {
        const $selection = $target.next().find('.select2-selection--multiple');
        const $clearBtn = $('<span class="select2-selection__clear" title="Clear all" style="cursor:pointer;">×</span>');
        
        $selection.append($clearBtn);

        $clearBtn.on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          $target.val([]).trigger('change').trigger('change.select2');
          $target.select2('close');
          $target.select2('open');
        });

        // Show/Hide clear button based on value
        $target.on('change.clearBtn', function () {
          const val = $(this).val();
          if (val.length > 0) {
            $clearBtn.show();
          } else {
            $clearBtn.hide();
          }
        });
        $target.trigger('change.clearBtn');
      }

      if (isMultiple) {
        // Backspace removes the entire last badge instead of editing it character by character.
        // Bind on capture phase to run before select2's internal keydown handler.
        const searchFieldEl = $target.next().find('.select2-search__field')[0];
        if (searchFieldEl) {
          searchFieldEl.addEventListener('keydown', function (e) {
            if (e.key !== 'Backspace' || this.value.length !== 0) return;

            const $selectedOptions = $target.find('option:selected');
            if ($selectedOptions.length === 0) return;

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            $selectedOptions.last().prop('selected', false);
            $target.trigger('change');
          }, true);
        }
      }

      // Hide dropdown when all results are already selected
      $target.on('select2:select select2:unselect change', function () {
        const select2Instance = $(this).data('select2');
        if (!select2Instance || !select2Instance.dropdown) return;
        
        const { $dropdown } = select2Instance;
        const selectedVal = $(this).val();
        const selectedCnt = selectedVal ? selectedVal.length : 0;

        // If nothing is selected, ensure dropdown is visible
        if (selectedCnt === 0) {
          $dropdown.removeClass('d-none');
          return;
        }

        const $results = $dropdown.find('.select2-results__option:not(.select2-results__message)');
        const $visibleResults = $results.filter((_, el) => $(el).attr('aria-selected') !== 'true');

        if ($results.length > 0 && $visibleResults.length === 0) {
          $dropdown.addClass('d-none');
        } else {
          $dropdown.removeClass('d-none');
        }
      });
    },
    /**
     * Set Datepicker With Flatpickr
     */
    setDatepicker() {
      const datepickerElList = document.querySelectorAll('input.datepicker');
      datepickerElList.forEach(function (el) {
        flatpickr(el, {
          allowInput: true,
          enableTime: el.dataset.type === 'datetime',
          enableSeconds: true,
          time_24hr: true,
          defaultDate: el.value,
          defaultHour: 0,
          defaultMinute: 0,
          defaultSeconds: 0,
          dateFormat: el.dataset.type === 'datetime' ? 'Y-m-d H:i:S' : 'Y-m-d',
          locale: {
            weekdays: {
              shorthand: ['일', '월', '화', '수', '목', '금', '토'],
              longhand: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
            },
            months: {
              shorthand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
              longhand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            },
            firstDayOfWeek: 0,
          },
          // 날짜 선택 후 처리
          // onChange(selectedDates, dateStr, instance) {
          //   const inputEl = instance._input;
          //   const rangeWrapEl = inputEl.closest('.incosheet-range-wrap');

          //   if (rangeWrapEl) {
          //     const startDateInput = rangeWrapEl.querySelector('.incosheet-start .incosheet-datepicker');
          //     const endDateInput = rangeWrapEl.querySelector('.incosheet-end .incosheet-datepicker');

          //     const selectedDate = selectedDates[0];

          //     if (inputEl === startDateInput) {
          //       endDateInput._flatpickr.set('minDate', selectedDate);
          //     } else if (inputEl === endDateInput) {
          //       startDateInput._flatpickr.set('maxDate', selectedDate);
          //     }
          //   }

          //   // change 이벤트 수동 발생
          //   inputEl.dispatchEvent(new Event('change'));
          // },
        });
      });
    },
    /**
     * Throttle function
     * Ensures the function is executed at most once every delay interval.
     * @param {Function} fn - The function to throttle
     * @param {number} delay - Minimum time between calls in milliseconds
     * @returns {Function} - A throttled version of the function
     */
    throttle(fn, delay = 200) {
      let lastCall = 0;
      return (...args) => {
        const now = Date.now();
        if (now - lastCall >= delay) {
          lastCall = now;
          fn.apply(this, args); // Execute if enough time has passed
        }
      };
    },
    /**
     * Debounce function
     * Executes the function after the specified delay only if
     * no further calls are made during that delay.
     * @param {Function} fn - The function to debounce
     * @param {number} delay - Delay in milliseconds
     * @returns {Function} - A debounced version of the function
     */
    debounce(fn, delay = 200) {
      let timer;
      return (...args) => {
        clearTimeout(timer); // Clear previous timer
        timer = setTimeout(function () {
          fn.apply(this, args); // Execute after delay
        }, delay);
      };
    },
    /**
     * Get CSS Breakpoint
     * @returns {string} Bootstrap Breakpoint
     */
    getBreakpoint() {
      let breakpoint = getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content');
      breakpoint = breakpoint.replaceAll('"', '');
      return breakpoint;
    },
    /**
     * Start Loading
     */
    startLoading() {
      let wrapElmnt = document.querySelector('.spinner-wrap');

      if (wrapElmnt) {
        wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) + 1;
      } else {
        wrapElmnt = document.createElement('div');
        wrapElmnt.classList.add('spinner-wrap');
        wrapElmnt.dataset.task = 1;
        const loadingElmnt = document.createElement('div');
        loadingElmnt.classList.add('spinner-border');
        loadingElmnt.classList.add('text-primary');
        const span = document.createElement('span');
        span.classList.add('visually-hidden');
        span.innerHTML = 'Loading...';
        loadingElmnt.appendChild(span);
        wrapElmnt.appendChild(loadingElmnt);

        const body = document.getElementsByTagName('body')[0];
        body.appendChild(wrapElmnt);
      }
    },
    /**
     * End Loading
     */
    endLoading() {
      setTimeout(function () {
        const wrapElmnt = document.querySelector('.spinner-wrap');

        if (wrapElmnt) {
          const taskCount = wrapElmnt.dataset.task;

          if (taskCount > 1) {
            wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) - 1;
          } else {
            wrapElmnt.style.opacity = 0;
            setTimeout(function () {
              wrapElmnt.remove();
            }, 300);
          }
        }
      }, 300);
    },
    /**
     * Set Range Slider
     * @param {string} id - nouislider-wrap id
     */
    setVafSlider(id) {
      const $wrap = $(`#${id}`);
      if (!$wrap.length) return;

      const $slider = $wrap.find('.nouislider');
      const $value = $wrap.find('.nouislider-value');
      const $min = $wrap.find('.nouislider-min');
      const $max = $wrap.find('.nouislider-max');

      // data attributes take priority over span text (for comma-formatted display)
      const min = $wrap.data('min') !== undefined ? $wrap.data('min') : ($min.length ? parseFloat($min.text()) : 0);
      const max = $wrap.data('max') !== undefined ? $wrap.data('max') : ($max.length ? parseFloat($max.text()) : 1);

      // Check for custom range segments
      const customSegments = $wrap.data('segments');
      const step = customSegments ? null : parseFloat($wrap.data('step')) || 0.1;
      let rangeConfig;
      let segmentStrings;

      if (customSegments) {
        // Parse custom segments: "0,0.0001,0.001,0.01,1"
        segmentStrings = customSegments
          .toString()
          .split(',')
          .map((v) => v.trim());
        const segments = segmentStrings.map(v => parseFloat(v));
        rangeConfig = { 'min': segments[0] };

        for (let i = 1; i < segments.length - 1; i++) {
          const percentage = (i / (segments.length - 1) * 100).toFixed(2) + '%';
          rangeConfig[percentage] = segments[i];
        }
        rangeConfig['max'] = segments[segments.length - 1];
      } else {
        rangeConfig = { min, max };
      }

      // Extract start values from text if data-start is missing
      let start = $wrap.data('start');
      if (!start && $value.length) {
        const text = $value.text();
        if (text.includes('~')) {
          start = [];
          text.split(',').forEach((range) => {
            range.split('~').forEach((val) => {
              // Extract number including negative sign and decimal
              const match = val.trim().match(/-?[\d.]+/);
              if (match) start.push(parseFloat(match[0]));
            });
          });
        } else {
          const match = text.match(/-?[\d.]+/);
          start = match ? [parseFloat(match[0])] : [min];
        }
      }
      start = start || [min, max];

      // Determine connect option based on handle count
      let connect = true;
      if (start.length === 1) {
        connect = [true, false];
      } else if (start.length === 4) {
        connect = [false, true, false, true, false];
      }

      // Determine decimal precision based on step or initial labels
      let decimal = 0;
      if (step) {
        decimal = step.toString().split('.')[1] ? step.toString().split('.')[1].length : 0;
      }
      if (decimal === 0 && !customSegments && $value.length) {
        const text = $value.text();
        const matches = text.match(/\.(\d+)/);
        if (matches) decimal = matches[1].length;
      }

      // Build segment value map for display (value -> original string)
      let segmentMap;
      if (customSegments && segmentStrings) {
        segmentMap = new Map();
        segmentStrings.forEach((s) => {
          segmentMap.set(parseFloat(s), s);
        });
      }

      const sliderOptions = {
        start,
        connect,
        range: rangeConfig,
      };

      // Add step and pips only if not using custom segments
      if (!customSegments) {
        const stepPercent = (step / (max - min)) * 100;
        sliderOptions.step = step;

        if (stepPercent < 5) {
          sliderOptions.pips = {
            mode: 'count',
            values: 6,
            density: 10,
            filter: (value) => {
              if (min < 0 && max > 0 && value === 0) return 1;
              return 0;
            },
          };
        } else {
          sliderOptions.pips = {
            mode: 'steps',
            density: stepPercent,
            filter: (value) => {
              // Only show 0 marker if range spans across 0
              if (min < 0 && max > 0 && value === 0) return 1;
              return 0;
            },
          };
        }
      } else {
        // For custom segments, snap to segment values and show pips without labels
        sliderOptions.snap = true;
        // Preserve raw number to avoid default 2-decimal rounding (e.g. 0.0001 -> "0.00")
        sliderOptions.format = {
          to: (value) => value,
          from: (value) => Number(value),
        };
        sliderOptions.pips = {
          mode: 'range',
          density: 100,
          format: {
            to: () => '',  // Hide all pip labels
            from: (value) => value,
          },
        };
      }

      const slider = noUiSlider.create($slider[0], sliderOptions);

      // Handle disabled state if checkbox exists
      const $checkbox = $wrap.parent().find('input[type="checkbox"]');
      if ($checkbox.length) {
        const toggleState = (checked) => {
          if (checked) {
            $slider[0].noUiSlider.disable();
            $wrap.addClass('disabled');
            $wrap.find('input[type="hidden"]').prop('disabled', true);
          } else {
            $slider[0].noUiSlider.enable();
            $wrap.removeClass('disabled');
            $wrap.find('input[type="hidden"]').prop('disabled', false);
          }
        };

        $checkbox.on('change', function () {
          toggleState(this.checked);
        });

        // Initial state
        toggleState($checkbox.prop('checked'));
      }

      // Check if comma formatting is enabled
      const useComma = $wrap.data('format') === 'comma';

      // Format number with segment map lookup or fixed decimal
      const formatNumber = (num) => {
        if (segmentMap) {
          const n = Number(num);
          if (segmentMap.has(n)) return segmentMap.get(n);
          return n.toLocaleString();
        }
        const fixed = Number(num).toFixed(decimal);
        if (useComma) {
          return Number(fixed).toLocaleString();
        }
        return fixed;
      };

      $slider[0].noUiSlider.on('update', function (values) {
        let displayValue = '';
        if (values.length === 4) {
          displayValue = `${formatNumber(values[0])} ~ ${formatNumber(values[1])}, ${formatNumber(values[2])} ~ ${formatNumber(values[3])}`;
        } else if (values.length === 2) {
          displayValue = `${formatNumber(values[0])} ~ ${formatNumber(values[1])}`;
        } else {
          displayValue = `≤ ${formatNumber(values[0])}`;
        }
        $value.text(displayValue);

        // Update hidden inputs
        const $hiddenInputs = $wrap.find('input[type="hidden"]');
        values.forEach((val, idx) => {
          if ($hiddenInputs.eq(idx).length) {
            $hiddenInputs.eq(idx).val(val);
          }
        });
      });

      return slider;
    },
    /**
     * Set Bar Chart (Horizontal)
     * @param {string} id - Element ID
     * @param {string[]} labels - Y-axis labels
     * @param {number[]} values - X-axis values
     */
    setBarChart(id, labels, values, highlightLabel = null, excludeLabels = []) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;

      // 1. Data preprocessing: Exclude labels
      let finalLabels = [];
      let finalValues = [];
      
      if (labels && values) {
        labels.forEach((label, index) => {
          if (!excludeLabels.includes(label)) {
            finalLabels.push(label);
            finalValues.push(values[index]);
          }
        });
      }

      // 2. Data preprocessing: Move 'highlightLabel' to the bottom if provided
      const rawSpecialIndex = highlightLabel ? finalLabels.findIndex((l) => l && l.includes(highlightLabel)) : -1;
      
      if (rawSpecialIndex > -1) {
        const itemLabel = finalLabels.splice(rawSpecialIndex, 1)[0];
        const itemValue = finalValues.splice(rawSpecialIndex, 1)[0];
        finalLabels.push(itemLabel);
        finalValues.push(itemValue);
      }

      const myChart = echarts.init(chartDom);
      const hasData = finalValues && finalValues.length > 0;
      const specialIndex = highlightLabel ? finalLabels.findIndex((l) => l && l.includes(highlightLabel)) : -1;

      const option = {
        grid: {
          left: '0',
          right: '12%', // Slightly more space for the label
          bottom: '10',
          top: '10',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          min: 0,
          max: hasData ? null : 100,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#E5E8EB',
            },
          },
          axisLabel: {
            color: '#b0b8c1',
            fontFamily: 'Pretendard',
            fontSize: 15,
            fontWeight: 500,
          },
        },
        yAxis: {
          type: 'category',
          data: finalLabels.length > 0 ? finalLabels : [''],
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: '#6788a8',
            fontFamily: 'Pretendard',
            fontSize: 16,
            fontWeight: 500,
          },
          // Dynamically apply separator line if highlightLabel exists
          splitLine: {
            show: true,
            interval: 0,
            lineStyle: {
              color: finalLabels.map((l, i) => (highlightLabel && i === specialIndex) ? '#D1D5DB' : 'transparent'),
              width: 1,
              type: 'solid'
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: 'transparent',
            }
          },
          inverse: true,
        },
        series: [
          {
            data: finalValues || [],
            type: 'bar',
            barWidth: 16,
            barCategoryGap: '35%',
            itemStyle: {
              borderRadius: [0, 8, 8, 0],
              color(params) {
                const colorList = ['#72c9c0', '#65bac8', '#59abd0', '#4d9cd9', '#408ce1', '#347de9'];
                return colorList[params.dataIndex % colorList.length];
              },
            },
            label: {
              show: true,
              position: 'right',
              color: '#333d4b',
              fontFamily: 'Pretendard',
              fontWeight: 500,
              fontSize: 15,
              offset: [8, 0],
            },
          },
        ],
      };
      myChart.setOption(option);
      myChart.on('mouseover', function () {
        chartDom.style.cursor = 'pointer';
      });
      myChart.on('mouseout', function () {
        chartDom.style.cursor = 'default';
      });
      window.addEventListener('resize', myChart.resize);
      return myChart;
    },
    /**
     * Set Line Chart
     * @param {string} id - Element ID
     * @param {string[]} labels - X-axis labels
     * @param {number[]} values - Y-axis values
     */
    setLineChart(id, labels, values) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      const myChart = echarts.init(chartDom);

      // Ensure minimum axis range even with empty data
      const hasData = values && values.length > 0;

      const option = {
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          top: '10%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: labels && labels.length > 0 ? labels : [''],
          axisLine: {
            lineStyle: { color: '#E5E8EB' },
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#6788a8',
            fontFamily: 'Pretendard',
            fontSize: 15,
            fontWeight: 500,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: hasData ? (value) => {
            return Math.ceil(value.max / 100) * 100 + 100;
          } : 100,
          interval: hasData ? 100 : 20,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#E5E8EB',
            },
          },
          axisLabel: {
            color: '#b0b8c1',
            fontFamily: 'Pretendard',
            fontSize: 15,
            fontWeight: 500,
          },
        },
        series: [
          {
            data: values || [],
            type: 'line',
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: {
              color: '#fff',
              borderColor: '#347de9',
              borderWidth: 2,
            },
            lineStyle: {
              color: '#347de9',
              width: 2,
            },
            label: {
              show: true,
              position: 'top',
              color: '#333d4b',
              fontFamily: 'Pretendard',
              fontWeight: 500,
              fontSize: 15,
            },
          },
        ],
      };
      myChart.setOption(option);
      myChart.on('mouseover', function () {
        chartDom.style.cursor = 'pointer';
      });
      myChart.on('mouseout', function () {
        chartDom.style.cursor = 'default';
      });
      window.addEventListener('resize', myChart.resize);
      return myChart;
    },
    /**
     * Set Doughnut Chart
     * @param {string} id - Element ID
     * @param {Object[]} data - [{value, name}, ...]
     */
    setDoughtChart(id, data) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      const myChart = echarts.init(chartDom);

      const total = data.reduce((sum, item) => sum + item.value, 0);
      const defaultIndex = data.findIndex((d) => d.name === 'MSI-H');
      let currentIndex = defaultIndex !== -1 ? defaultIndex : 0; // Track current hover index

      const updateCenterLabel = (index) => {
        const item = data[index];
        const percent = total > 0 ? Math.round((item.value / total) * 100) : 0;
        myChart.setOption({
          series: [
            {
              label: {
                formatter: `{name|${item.name}}\n{percent|${percent}} {unit|%}`,
              },
            },
          ],
        });
      };

      const option = {
        color: ['#347de9', '#72c9c0', '#e5e8eb'],
        legend: {
          orient: 'vertical',
          left: 'center',
          top: 'bottom',
          itemGap: 20,
          itemWidth: 12,
          itemHeight: 12,
          icon: 'circle',
          formatter: (name) => {
            const item = data.find((d) => d.name === name);
            return `{name|${name}}{value|${item ? item.value : 0}}`;
          },
          textStyle: {
            rich: {
              name: {
                color: '#6788a8',
                fontFamily: 'Pretendard',
                fontSize: 16,
                fontWeight: 500,
                width: 120,
                padding: [2, 0, 0, 2],
                verticalAlign: 'middle',
              },
              value: {
                color: '#333d4b',
                fontSize: 14,
                fontWeight: 600,
                padding: [4, 0, 0, 0],
                verticalAlign: 'middle',
              },
            },
          },
        },
        series: [
          {
            name: 'Chart',
            type: 'pie',
            radius: ['40%', '60%'],
            center: ['50%', '38%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              formatter: () => {
                const item = data[currentIndex];
                const percent = total > 0 ? Math.round((item.value / total) * 100) : 0;
                return `{name|${item.name}}\n{percent|${percent}} {unit|%}`;
              },
              rich: {
                name: {
                  color: '#6788a8',
                  fontSize: 12,
                  lineHeight: 18,
                },
                percent: {
                  color: '#333d4b',
                  fontSize: 18,
                  fontWeight: 600,
                  lineHeight: 21,
                },
                unit: {
                  color: '#333d4b',
                  fontSize: 12,
                  fontWeight: 400,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
              },
            },
            labelLine: {
              show: false,
            },
            data,
            itemStyle: {
              borderWidth: 0,
            },
          },
        ],
      };
      myChart.setOption(option);

      // Handle mouse events
      myChart.on('mouseover', (params) => {
        if (params.dataIndex !== undefined) {
          currentIndex = params.dataIndex;
          updateCenterLabel(currentIndex);
        }
        chartDom.style.cursor = 'pointer';
      });
      myChart.on('mouseout', () => {
        chartDom.style.cursor = 'default';
      });

      window.addEventListener('resize', myChart.resize);
      return myChart;
    },

    /**
     * Set Tiptab
     * @param {string} id - Element ID
     * @param {object} options - Editor options
     * @returns {object} - Tiptap Editor instance
     */
    setEditor(id, options) {
      const el = $(id)[0];
      if (!el) return null;

      const $el = $(el);
      $el.addClass('tiptap-editor-target');

      const isEditable = options.editable !== undefined ? options.editable : !options.readonly;

      // Wrap the editor
      $el.wrap(`<div class="editor-wrap${!isEditable ? ' readonly' : ''}"></div>`);
      const $wrap = $el.parent();

      const editor = new TiptapEditor({
        element: el,
        extensions: [
          TiptapStarterKit.configure({
            blockquote: false,
            code: false,
            codeBlock: false,
            horizontalRule: false,
          }),
          TiptapPlaceholder.configure({
            placeholder: options.placeholder || '',
          }),
        ],
        content: options.content,
        editable: isEditable,
        onFocus: () => {
          $wrap.addClass('focused');
        },
        onBlur: () => {
          $wrap.removeClass('focused');
        },
      });

      if (isEditable) {
        this.setEditorToolbar(editor, $wrap);
      }

      return editor;
    },

    /**
     * Create and bind Tiptap Toolbar
     * @param {object} editor - Tiptap Editor instance
     * @param {object} $wrap - Editor wrapper element
     */
    setEditorToolbar(editor, $wrap) {
      const toolbarHtml = `
        <div class="editor-toolbar">
          <button type="button" class="toolbar-btn" data-command="bold" title="Bold"><i class="material-icons-outlined">format_bold</i></button>
          <button type="button" class="toolbar-btn" data-command="italic" title="Italic"><i class="material-icons-outlined">format_italic</i></button>
          <button type="button" class="toolbar-btn" data-command="strike" title="Strike"><i class="material-icons-outlined">strikethrough_s</i></button>
          <div class="toolbar-divider"></div>
          <button type="button" class="toolbar-btn" data-command="h1" title="Heading 1"><i class="material-icons-outlined">looks_one</i></button>
          <button type="button" class="toolbar-btn" data-command="h2" title="Heading 2"><i class="material-icons-outlined">looks_two</i></button>
          <button type="button" class="toolbar-btn" data-command="h3" title="Heading 3"><i class="material-icons-outlined">looks_3</i></button>
          <div class="toolbar-divider"></div>
          <button type="button" class="toolbar-btn" data-command="bulletList" title="Bullet List"><i class="material-icons-outlined">format_list_bulleted</i></button>
          <button type="button" class="toolbar-btn" data-command="orderedList" title="Ordered List"><i class="material-icons-outlined">format_list_numbered</i></button>
          <div class="toolbar-divider"></div>
          <button type="button" class="toolbar-btn" data-command="link" title="Link"><i class="material-icons-outlined">link</i></button>
          <button type="button" class="toolbar-btn" data-command="unlink" title="Unlink"><i class="material-icons-outlined">link_off</i></button>
        </div>
      `;

      $wrap.prepend(toolbarHtml);
      const $toolbar = $wrap.find('.editor-toolbar');

      const commands = {
        bold: () => editor.chain().focus().toggleBold().run(),
        italic: () => editor.chain().focus().toggleItalic().run(),
        strike: () => editor.chain().focus().toggleStrike().run(),
        h1: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
        h2: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
        h3: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
        bulletList: () => editor.chain().focus().toggleBulletList().run(),
        orderedList: () => editor.chain().focus().toggleOrderedList().run(),
        link: () => {
          const previousUrl = editor.getAttributes('link').href;
          const url = window.prompt('URL', previousUrl);

          if (url === null) {
            return;
          }

          if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
          }

          editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
        },
        unlink: () => editor.chain().focus().unsetLink().run(),
        undo: () => editor.chain().focus().undo().run(),
        redo: () => editor.chain().focus().redo().run(),
      };

      $toolbar.on('click', '.toolbar-btn', (e) => {
        const command = $(e.currentTarget).data('command');
        if (commands[command]) {
          commands[command]();
        }
      });

      // Update active state
      editor.on('transaction', () => {
        $toolbar.find('.toolbar-btn').each(function () {
          const command = $(this).data('command');
          let isActive = false;

          switch (command) {
            case 'bold':
              isActive = editor.isActive('bold');
              break;
            case 'italic':
              isActive = editor.isActive('italic');
              break;
            case 'strike':
              isActive = editor.isActive('strike');
              break;
            case 'h1':
              isActive = editor.isActive('heading', { level: 1 });
              break;
            case 'h2':
              isActive = editor.isActive('heading', { level: 2 });
              break;
            case 'h3':
              isActive = editor.isActive('heading', { level: 3 });
              break;
            case 'bulletList':
              isActive = editor.isActive('bulletList');
              break;
            case 'orderedList':
              isActive = editor.isActive('orderedList');
              break;
            case 'link':
              isActive = editor.isActive('link');
              break;
            default:
              break;
          }

          if (isActive) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });
      });
    },
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  Utils.setDatepicker();
  Utils.setSelect2();
});

